import React, { FC, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
const ProfileNotContent = () => {
  const handleRefresh = (): void => {
    window.location.reload();
  };
return (
    <div className="pds-unauthenticatedError">
    <div className="pds-unauthenticatedError-background">
      <section className="pds-imgStanTheMan pds-util-padding-top-20 pds-util-padding-bottom-10">
        <div className="pds-typography-center">
          <div>
            <h1 className="pds-typography-h2 pds-util-margin-top-10 pds-util-margin-bottom-0">Server Error 403 Forbidden</h1>
          </div>
          <div className="pds-util-padding-horz-10">
            <p className="pds-util-margin-vert-0">No tienes permisos para acceder a esta pagina</p>
            <p className="pds-util-margin-vert-0">
            </p>
          </div>
        </div>
      </section>
      <div className="pds-color-bg-core-1 pds-typography-center pds-util-padding-vert-10">
      &nbsp;
   <span><a href="#" className="pds-button pds-button-secondary" onClick={handleRefresh}>
   Recargar pagina</a></span>
   &nbsp;
    <Link to="/"> 
    <span><a href="#" className="pds-button pds-button-secondary">
    Volver al inicio </a></span>
    </Link>
</div>
    </div>
  </div>

);
}

export default ProfileNotContent;